import Button from 'components/Button/Button'
import { ModalTemplate } from 'components/ModalTemplate'
import { Text } from 'components/Text'
import styled from 'styled-components'

export const DiscardedAppointmentContainer = styled.div``

export const DiscardedAppointmentItemText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`

export const DiscardedAppointmentModalContainer = styled(ModalTemplate)``

export const DiscardedAppointmentModalContent = styled.div`
  margin: 25px 0;
`

export const DiscardedAppointmentModalDes = styled.p``

export const DiscardedAppointmentModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`
export const DiscardedAppointmentModalButton = styled(Button)`
  width: 47%;
`
